/**
 * Filter to converter string a uppercase
 * @version 1.0.0
 * @author Efrén Martínez Rodríguez
 * @copyright Marciano Studio S.C., 2018
 */
import Vue from 'vue'
export default Vue.filter('uppercase', value => value.toUpperCase())



// WEBPACK FOOTER //
// ./src/filters/string.filters/uppercase.filter.js